import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { reduxForm } from 'redux-form';
import Form from 'erpcore/components/Form';

import { insertIf } from 'erpcore/utils/utils';
import remove from 'lodash/remove';

import Button from 'erpcore/components/Button';
import Tooltip from 'erpcore/components/Tooltip';

import { actions as rolesActions } from 'erpcore/screens/Settings/Roles/Roles.reducer';

const RemoveRoleFromUser = ({ handleSubmit, submitting, userData, roleIri, callback }) => {
    const dispatch = useDispatch();

    const onSubmit = () => {
        const { iri: userIri, roles } = { ...userData };

        const rolesCopy = [...roles];

        // Remove role from roles
        remove(rolesCopy, role => role === roleIri);

        // join new roles, permissions and userTypes
        const formData = {
            roles: [
                ...insertIf(rolesCopy?.length, rolesCopy),
                ...insertIf(userData?.permissions?.length, userData.permissions),
                ...insertIf(userData?.userTypes?.length, userData.userTypes)
            ]
        };

        return new Promise((resolve, reject) =>
            dispatch({
                promise: { resolve, reject },
                type: rolesActions.START_REMOVE_ROLE_FROM_USER,
                userIri,
                formData
            })
        )
            .then(() => {
                if (callback) {
                    callback();
                }
            })
            .catch(error => {
                return error;
            });
    };

    return (
        <Form onSubmit={handleSubmit(onSubmit)}>
            <Tooltip content="Remove role from user">
                <Button
                    submit
                    variation="table-action"
                    iconName="minusCircle"
                    loading={submitting}
                    label=""
                />
            </Tooltip>
        </Form>
    );
};

RemoveRoleFromUser.defaultProps = {
    submitting: false,
    userData: null,
    roleIri: null,
    callback: () => {}
};

RemoveRoleFromUser.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    userData: PropTypes.oneOfType([PropTypes.object]),
    roleIri: PropTypes.string,
    callback: PropTypes.func
};

export default reduxForm({
    enableReinitialize: false,
    form: 'RemoveRoleFromUserForm'
})(RemoveRoleFromUser);
